module.exports = __webpack_public_path__ + "img/download-tile-bg-desktop__en.d4e61c5.jpg";